import React, { useEffect, useState } from "react";
import CustomBtn from "./CustomBtn";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import apis from "services";
import { formatDate } from "utils/formatDate";
import { CircularProgress } from "@mui/material";

const ViewTicketDetailsForm = ({ ticketId }) => {
  const { lang } = useParams();
  const [ticket, setTicket] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGetTicketById = async () => {
    try {
      setLoading(true);
      const res = await apis.getTicketById(ticketId);
      if (res?.data?.status) {
        setTicket(res.data.data);
      } else {
        toast.error(res.data.message);
      }
    } catch (e) {
      toast.error(e.message || "Something went wrong! Please try again");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetTicketById();
  }, [ticketId]);

  return (
    <div className="view-ticket-details">
      <h1>Ticket Details</h1>

      {loading ? (
        <div className="ticket-loader">
          <CircularProgress color="error" />
        </div>
      ) : !Object.keys(ticket).length ? (
        <p className="no-record-found">No Found</p>
      ) : (
        <div className="grid">
          <div>
            <h6>Ticket Id</h6>
            <p>{ticket._id}</p>
          </div>
          <div>
            <h6>User Name</h6>
            <p>{ticket?.userId?.name}</p>
          </div>
          <div>
            <h6>Ticket Subject</h6>
            <p>{ticket.subject}</p>
          </div>
          <div>
            <h6>Attachment</h6>
            <p>
              <img
                src={`${process.env.REACT_APP_SERVER_URL}${ticket.attachment}`}
                alt={ticket.subject}
                className="ticket-image"
              />
            </p>
          </div>
          <div>
            <h6>Priority</h6>
            <p>
              <span
                className={`custom-badge ${
                  ticket.priority === "High"
                    ? "red-badge"
                    : ticket.priority === "Medium"
                    ? "orange-badge"
                    : "yellow-badge"
                }`}
              >
                {ticket.priority}
              </span>
            </p>
          </div>
          <div>
            <h6>Date</h6>
            <p>{formatDate(ticket.createdAt)}</p>
          </div>
          <div>
            <h6>Category</h6>
            <p>{ticket.category}</p>
          </div>
          <div>
            <h6>Status</h6>
            <p>
              <span
                className={`custom-badge ${
                  ticket.status === "open"
                    ? "orange-badge"
                    : ticket.status === "closed"
                    ? "green-badge"
                    : "yellow-badge"
                }`}
              >
                {ticket.status}
              </span>
            </p>
          </div>
          <div>
            <h6>Description</h6>
            <p>{ticket.description}</p>
          </div>
        </div>
      )}

      <div>
        <Link to={`/${lang}/admin/tickets/${ticketId}`}>
          <CustomBtn
            title={"View Full Details"}
            widthInPx={""}
          />
        </Link>
      </div>
    </div>
  );
};

export default ViewTicketDetailsForm;
